import React, { useEffect, useState } from "react";
import { Star, Heart } from "lucide-react";
import { Link } from "react-router-dom";

const HotelCard = ({ hotel }) => {
  const [hotelType, setHotelType] = useState(3);
  const image = hotel.images?.hotel?.[0] || "https://via.placeholder.com/150";
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setHotelType(Number(hotel.type.replace(/\D/g, "")));
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const reviews = 1310;
  const price = 2521;
  const originalPrice = 5550;
  const discount = originalPrice - price;
  const roomsLeft = 1;

  const formatAmenities = (input) => {
    const amenities = input.match(
      /(Free Wi-Fi|Paid breakfast|Free parking|Accessible|Laundry service|Room service|Outdoor pool|Air-conditioned|Free breakfast|Parking|Pool)/g
    );
    if (!amenities) return "";
    return amenities.join(", ");
  };

  const output = formatAmenities(hotel.amenities);

  if (isMobile) {
    return (
      <div className="rounded-3xl shadow-lg overflow-hidden bg-white border border-gray-200 mb-6">
        <div className="relative">
          <img
            src={image}
            alt={hotel.name}
            className="object-cover w-full h-64 md:h-72 rounded-t-3xl"
          />

          <div className="absolute top-2 left-2 bg-orange-100 text-orange-700 text-xs px-2 py-1 rounded-md font-semibold">
            Last Minute Deal
          </div>

          <Heart className="absolute top-2 right-2 text-white bg-black bg-opacity-30 p-1 rounded-full cursor-pointer" />
        </div>

        <div className="p-4">
          <h2 className="text-lg font-semibold text-gray-800 flex items-center gap-1">
            {hotel.name}
            <span className="flex ml-2 text-yellow-500">
              {[...Array(hotelType)].map((_, i) => (
                <Star key={i} size={16} fill="currentColor" strokeWidth={0} />
              ))}
            </span>
          </h2>

          <p className="text-sm text-gray-600 mt-1">{hotel.location}</p>

          <div className="flex items-center mt-2 space-x-2">
            <span className="bg-black text-white text-xs px-2 py-1 rounded font-semibold">
              {hotel.rating}
            </span>
            <span className="text-sm text-gray-700 font-medium">
              {Number(hotel.rating) >= 8 ? "Excellent" : Number(hotel.rating) > 4 ? "Good" : "Average"}
            </span>
            <span className="text-sm text-gray-400">• {reviews} Ratings</span>
          </div>

          <div className="text-green-700 mt-2 text-sm font-medium">
            {output}
          </div>

          <div className="mt-3 text-sm text-gray-600">
            ✨ Convenient location with friendly service and clean rooms.
          </div>

          {/* <div className="mt-4 text-sm text-gray-900 flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <div className="mb-3 sm:mb-0">
              <div className="text-gray-400 line-through text-xs">₹{originalPrice.toLocaleString()}</div>
              <div className="text-2xl font-bold">₹{price.toLocaleString()}</div>
              <div className="text-xs text-gray-500">+ ₹649 taxes & fees per night, per room</div>
            </div>

            <div className="bg-green-100 text-sm text-green-600 px-2 py-1 rounded-md">
              Discount of ₹{discount} included. Coupon code NEW15 applied!
            </div>
          </div> */}

          <div className="mt-4 flex gap-4">
            <Link
              to={`/hotels/${hotel.id}`}
              className="border border-gray-300 px-4 py-2 rounded-md text-gray-800 hover:bg-gray-50 text-sm"
            >
              View Details
            </Link>
            <Link
              to={`/book/${hotel.id}`}
              className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-md text-sm"
            >
              Book Now
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // Desktop layout
  return (
    <div className="flex flex-row rounded-2xl shadow-lg overflow-hidden lg:w-full h-72 max-w-5xl mx-auto mb-6 border border-gray-200">
      <div className="relative w-full md:w-1/3 h-60 md:h-auto">
        <img src={image} alt={hotel.name} className="object-cover w-full h-full" />
        <div className="absolute top-2 left-2 bg-green-100 text-green-700 text-xs px-2 py-1 rounded">
          Exclusive Deal
        </div>
        <Heart className="absolute top-2 right-2 text-white bg-black bg-opacity-30 p-1 rounded-full cursor-pointer" />
      </div>

      <div className="flex-1 p-4 flex flex-col justify-between">
        <div>
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-800">
              {hotel.name}
              <span className="flex ml-2 text-yellow-500">
                {[...Array(hotelType)].map((_, i) => (
                  <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
                ))}
              </span>
            </h2>
            <div className="text-sm text-red-600 font-semibold">
              {roomsLeft <= 1 ? `Last ${roomsLeft} room left` : `${roomsLeft} rooms left`}
            </div>
          </div>

          <p className="text-sm text-gray-500">{hotel.location}</p>

          <div className="flex items-center mt-2 space-x-2">
            <span className="bg-black text-white text-xs px-2 py-1 rounded font-semibold">
              {hotel.rating}
            </span>
            <span className="text-sm text-gray-700 font-medium">
              {Number(hotel.rating) > 4 ? "Excellent" : "Good"}
            </span>
            <span className="text-sm text-gray-400">• {reviews} Ratings</span>
          </div>

          <div className="mt-2 text-green-600 font-medium text-sm">{output}</div>

          <div className="flex space-x-4 text-sm text-gray-600 mt-2">
            <div className="flex items-center">24*7 Check-in</div>
            <div className="flex items-center">Restaurants</div>
          </div>
        </div>

        <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <Link to={`/hotels/${hotel.id}`} className="border px-4 py-2 rounded no-underline">
            View Details
          </Link>
          <Link
            to={`/book/${hotel.id}`}
            className="mt-2 sm:mt-0 w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white font-semibold px-4 py-2 rounded no-underline"
          >
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HotelCard;
